
// export const myGetter = ( state ) => {
//  return state
// }

export const dealersList = state => state.dealers
export const dealersSelectable = state => state.dealersSelectable
export const dealersPaginatedData = state => state.dealersPaginatedData
export const dealer = state => state.dealer
export const isLoading = state => state.isLoading
export const isCreating = state => state.isCreating
export const isUpdating = state => state.isUpdating
export const createdData = state => state.createdData
export const updatedData = state => state.updatedData
export const isDeleting = state => state.isDeleting
export const deletedData = state => state.deletedData